import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const Listado = WithErrorBoundary(
  'Usuarios',
  'Error en modulo de usuarios y perfiles',
  React.lazy(() => import('./Listado')),
)

const NuevoUsuario = WithErrorBoundary(
  'Usuarios',
  'Error en modulo de usuarios y perfiles',
  React.lazy(() => import('./NuevoUsuario')),
)

const EditarUsuario = WithErrorBoundary(
  'Usuarios',
  'Error en modulo de usuarios y perfiles',
  React.lazy(() => import('./EditarUsuario')),
)

const ConfirmUserAccount = WithErrorBoundary(
  'Usuarios',
  'Error en modulo de usuarios y perfiles',
  React.lazy(() => import('./ConfirmUserAccount')),
)

const MainGestionUsuario = WithErrorBoundary(
  'Usuarios',
  'Error en modulo de usuarios y perfiles',
  React.lazy(() => import('./gestion-usuario/MainGestionUsuarioContainer')),
)

export default {
  path: 'usuarios',
  name: 'Usuarios',
  childRoutes: [
    { path: '', name: 'Listado', component: Listado, isIndex: true },
    { path: 'crear', name: 'Nuevo usuario', component: NuevoUsuario },
    { path: 'editar/:id', name: 'Editar usuario', component: EditarUsuario },
    { path: '/usuarios/confirmar/:id', name: 'Confirmar usuario', component: ConfirmUserAccount },
    { path: 'editar-usuario', name: 'Editar perfil', component: MainGestionUsuario },
  ],
};
